import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, truncateText, DESCRIPTION_TRUNCATE_LEN, promptTemplateEditPath } from '../constants';

function PromptTemplatesMobileList({ templates }) {
  return (
    <div className="md:hidden space-y-3">
      {templates.map((template) => (
        <div key={template.slug} className="surface-card p-4 space-y-3">
          <div className="min-w-0">
            <p className="font-medium text-content-primary font-mono text-xs break-all">
              {template.slug}
            </p>
            <p className="text-sm text-content-muted mt-1">{template.category || '—'}</p>
          </div>
          <p className="text-sm text-content-muted" title={template.description || undefined}>
            {truncateText(template.description, DESCRIPTION_TRUNCATE_LEN)}
          </p>
          <p className="text-xs text-content-subtle">{formatDate(template.updated_at)}</p>
          <Link
            to={promptTemplateEditPath(template.slug)}
            className="btn-secondary text-xs px-3 py-2 inline-block"
          >
            Editar
          </Link>
        </div>
      ))}
    </div>
  );
}

export default PromptTemplatesMobileList;
